export default __webpack_public_path__ + "static/media/Wow.6f845ee3.gif";